define('modules/editor/models/property_groups/form_content',['require','exports','module','./base','lib/util','../../behaviours/localizable_property_group'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:content",
    properties: ["content"],
    editAllowed: false,
    localizableAttrs: ["content"],
    applyStyles: function($el){
      $el.find(".js-fields").html(this.get("content"));
    }
  });

  util.mixin(module.exports, require("../../behaviours/localizable_property_group"));
});

